import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useSuiteStore } from './useSuiteStore'

export interface BusinessUnitItem {
  bu: string
  preferences: Record<string, unknown> | null
  dateCreated: string
  dateUpdated: string
}

export const useBusinessUnitAdminStore = defineStore('businessUnitAdmin', () => {
  const suiteStore = useSuiteStore()
  const items = ref<BusinessUnitItem[]>([])
  const isLoading = ref(false)

  async function fetchAll() {
    isLoading.value = true
    try {
      const res = await suiteStore.suiteFetch('business-units')
      if (res && res.ok) {
        items.value = await res.json()
      }
    } finally {
      isLoading.value = false
    }
  }

  async function updatePreferences(bu: string, preferences: Record<string, unknown>): Promise<boolean> {
    const res = await suiteStore.suiteFetch(`business-units/${bu}/preferences`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ preferences }),
    })
    if (!res || !res.ok) return false
    const updated: BusinessUnitItem = await res.json()
    const idx = items.value.findIndex((i) => i.bu === bu)
    if (idx !== -1) items.value[idx] = updated
    return true
  }

  return { items, isLoading, fetchAll, updatePreferences }
})
